import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterDeviceListInterface } from '../../../interface/schedule-management.interface';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { fetchAllStationsList } from '../../../redux/slice/ApprovedStationManagementSlice';
import {
  fetchAllDevicesList,
  fetchOneDevicePoints,
} from '../../../redux/slice/DeviceManagementSlice';
import MyButton from '../../../shared-components/button/Button';
import MultiSelectDropdown from '../../../shared-components/multi-select-field/MultiSelectField';

interface AddRoleInterface {
  closeModal: () => void;
}
/**
 * Helper function to normalize selected values into an array
 * @param {string | number | string[]} value - The value to normalize.
 */
const getSelectedValues = (value: string | number | string[]) => {
  if (Array.isArray(value)) return value;
  return value ? [String(value)] : [];
};

/**
 * Role Add page function component
 */
function DeviceFilter({ closeModal }: AddRoleInterface) {
  const { t } = useTranslation('scheduleManagement');
  const dispatch = useAppDispatch();
  const { allStations, loading } = useAppSelector((state) => state.approvedStation);
  const { allDevices } = useAppSelector((state) => state.device);
  const [filterDetails, setFilterDetails] = useState<FilterDeviceListInterface>({
    station: '',
    device: '',
  });

  /**
   * Get data function
   */
  const fetchData = () => {
    if (!loading) {
      dispatch(fetchAllStationsList());
    }
  };

  /**
   * Handle the input change function
   * @param {string} name - The name of the field.
   * @param {string | number | string[]} value - The new value.
   */
  const handleInputChange = (name: string, value: string | number | string[]) => {
    setFilterDetails((previous) => ({
      ...previous,
      [name]: value,
    }));
    if (name === 'station') {
      const stationId = Array.isArray(value) ? value[0] : value;
      if (stationId) {
        dispatch(fetchAllDevicesList({ id: stationId }));
      }
    }
  };

  /**
   * Handle the submit function
   */
  const handleSubmit = () => {
    const deviceId = Array.isArray(filterDetails.device)
      ? filterDetails.device[0]
      : filterDetails.device;
    if (deviceId) {
      dispatch(fetchOneDevicePoints({ id: deviceId }));
    }
    closeModal();
  };

  useEffect(() => {
    if (allStations.length === 0) {
      fetchData();
    }
  }, []);

  const selectedStations = getSelectedValues(filterDetails.station);
  const selectedDevices = getSelectedValues(filterDetails.device);

  return (
    <div className="filter-user-warp">
      <div className="form-field">
        <MultiSelectDropdown
          placeholder={t('selectStation')}
          title={t('stationNameOrId')}
          name="station"
          options={allStations}
          selectedValues={selectedStations}
          onSelectionChange={handleInputChange}
          placeholderFilled={t('stations')}
          search
        />
      </div>
      <div className="form-field">
        <MultiSelectDropdown
          placeholder={t('selectDevice')}
          title={t('device')}
          name="device"
          options={allDevices}
          selectedValues={selectedDevices}
          onSelectionChange={handleInputChange}
          placeholderFilled={t('devices')}
          search
        />
      </div>
      <div className="filter-user-button">
        <MyButton label={t('cancel')} buttonType="back" onClickFunc={closeModal} />
        <MyButton label={t('apply')} buttonType="submit" onClickFunc={handleSubmit} />
      </div>
    </div>
  );
}

export default DeviceFilter;
